const SCALE = 10_000n;

function calculateTroopTrainingTime(baseTrainingTime, barracksLevel, amount, gameSpeed = 1) {
	const factor = SCALE + BigInt(barracksLevel) * 300n;
	const timePerTroop = BigInt(baseTrainingTime) * SCALE / factor;
	return Number(timePerTroop * BigInt(amount) / BigInt(gameSpeed));
}

function calculateTroopResourceCost(unit, amount, barracksLevel, gameSpeed = 1) {
	return {
		food: unit.food_cost * amount,
		gold: unit.gold_cost * amount,
		mana: unit.mana_cost * amount,
		population: unit.population_cost * amount,
		blocks: calculateTroopTrainingTime(unit.training_time, barracksLevel, amount, gameSpeed),
	};
}

module.exports = {
	SCALE,
	calculateTroopResourceCost,
	calculateTroopTrainingTime,
};
